var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AxisBottom, AxisLeft, AxisRight, AxisTop } from '@visx/axis';
import { useCanvas } from '../../components/Canvas';
import { color, palette } from '../../../constants';
import { Base } from '../Axis.styles';
var TICK_LENGTH = 10;
var TICK_COLOUR = palette.neutral4;
export var axisStyleProps = {
    tickLength: TICK_LENGTH,
    tickStroke: TICK_COLOUR,
    stroke: TICK_COLOUR
};
var defaultTickLabelStyles = {
    fill: color.theme.typography.ink,
    fontSize: 12
};
function getDefaultProps(tickProps) {
    if (tickProps === void 0) { tickProps = {}; }
    tickProps = __assign(__assign({}, defaultTickLabelStyles), tickProps);
    return __assign(__assign({}, axisStyleProps), { tickComponent: function (_a) {
            var formattedValue = _a.formattedValue, args = __rest(_a, ["formattedValue"]);
            return (React.createElement("text", __assign({}, args, tickProps), formattedValue));
        } });
}
function getAxisComponent(orientation) {
    switch (orientation) {
        case 'top':
            return AxisTop;
        case 'right':
            return AxisRight;
        case 'bottom':
            return AxisBottom;
        case 'left':
            return AxisLeft;
    }
}
export function AxisBase(props) {
    var orientation = props.orientation, top = props.top, left = props.left, tickProps = props.tickProps, rest = __rest(props, ["orientation", "top", "left", "tickProps"]);
    var _a = useCanvas(), boundedWidth = _a.boundedWidth, boundedHeight = _a.boundedHeight;
    var offsetTop = orientation === 'bottom' && top === undefined ? boundedHeight : top;
    var offsetLeft = orientation === 'right' && left === undefined ? boundedWidth : left;
    var AxisComponent = React.useMemo(function () { return getAxisComponent(props.orientation); }, [props.orientation]);
    var combinedProps = __assign(__assign({}, getDefaultProps(tickProps)), rest);
    return (React.createElement(Base, { orientation: orientation },
        React.createElement(AxisComponent, __assign({ labelClassName: "Axis--label", left: offsetLeft, top: offsetTop }, combinedProps))));
}
//# sourceMappingURL=AxisBase.js.map